import { render } from "./BlockListRender.vue?vue&type=template&id=e6935050&scoped=true"
import script from "./BlockListRender.vue?vue&type=script&lang=js"
export * from "./BlockListRender.vue?vue&type=script&lang=js"

import "./BlockListRender.vue?vue&type=style&index=0&id=e6935050&scoped=true&lang=less"
import "./BlockListRender.vue?vue&type=style&index=1&id=e6935050&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6935050"]])

export default __exports__